import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
// import { Location, LocationStrategy, PathLocationStrategy, PopStateEvent } from '@angular/common';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { RequestServiceService } from 'src/app/core/services/request-service/request-service.service';
import { MessagesService } from 'src/app/core/services/messages/messages.service';
// import { Subscription } from 'rxjs/Subscription';
// import PerfectScrollbar from 'perfect-scrollbar';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit {
  isExpanded: any = false;
  klass_nav: string = "open-nav";
  sidebarVisible: boolean = false;
  restroName: any;
  logoIMage: any;
  change_nav() {
    //console.log(this.isExpanded);
    if (this.isExpanded) {
      this.klass_nav = "closed-nav"
    } else {
      this.klass_nav = "open-nav"
    }
    this.isExpanded = !this.isExpanded
  }


  ngOnInit() {
    this.sidebarVisible = false

    this.requestService.nickname$.subscribe((nickname) => {
      //console.log(nickname, 'jj')
      this.restroName = nickname ? nickname : JSON.parse(localStorage.getItem('userData') || '{}').res_name ? nickname ? nickname : JSON.parse(localStorage.getItem('userData') || '{}').res_name : 'N/A';
    });
    this.requestService.logoImage$.subscribe((logoImage) => {
      //console.log(logoImage, 'jj')
      this.logoIMage = logoImage ? logoImage : JSON.parse(localStorage.getItem('userData') || '{}').logo_image ? logoImage ? logoImage : JSON.parse(localStorage.getItem('userData') || '{}').logo_image : 'N/A';
    });
  }
  
  closseFunction() {
   
    this.requestService.logout().then(response => {
      console.log(response)
      if (response.success) {
        localStorage.clear()
        this.router.navigate([this.authService.getLoginUrl()]);
        this.messageservices.showNotification(response.msg, 'success', 'success');

      } else {

        this.messageservices.showNotification(response.msg, 'error', 'error');
        console.log(response.msg);
        // Handle login error
      }
    });
   
  }
  constructor(private router: Router, private authService: AuthService, private requestService: RequestServiceService,   public messageservices: MessagesService) {

    this.sidebarVisible = false;

  }



}
